import { useNavigate } from "react-router-dom"
import { AdminHeader } from "./AdminHeader"

export const OptionalSubjectList = () => {
    const Navigate = useNavigate()
    return (
        <>
            <div className="row px-4 " style={{ background: "#F2F2F2" }}>

                <AdminHeader />

                <div className="col-6 pt-5">
                    <h5 className="fw-bold pt-3 pb-2"> Optional Subject</h5>
                </div>

                <div className="col-12 pb-5">
                    <div className="shadows bg-white row rounded p-3">

                        <div className="row">
                            <div className="col-12 col-lg-4 p-lg-4">
                                <div className="row rounded shadows_div p-3">
                                    <div className="col-lg-9 ">
                                        <p className="mb-0 pb-0">Regulations of Insurance Business </p>
                                    </div>
                                    <div className="col-lg-3 border-left">
                                        <h4 className="text-danger fw-bold mb-0 cursor-pointer text-center" onClick={() => Navigate('/LicentiateCertificate')}>5</h4>
                                    </div>
                                    
                                </div>

                                
                            </div>

                            <div className="col-12 col-lg-4 p-lg-4">
                                <div className="row rounded shadows_div p-3">
                                    <div className="col-lg-9 ">
                                        <p className="mb-0 pb-0">Health Insurance </p>
                                    </div>
                                    <div className="col-lg-3 border-left">
                                        <h4 className="text-danger fw-bold mb-0 text-center">100</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-4 p-lg-4">
                                <div className="row rounded shadows_div p-3">
                                    <div className="col-lg-9 ">
                                        <p className="mb-0 pb-0">General Insurance Claims </p>
                                    </div>
                                    <div className="col-lg-3 border-left">
                                        <h4 className="text-danger fw-bold mb-0 text-center">10</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>



            </div>
        </>
    )
}